import Hero from '../components/Hero';
import Features from '../components/Features';
import Specifications from '../components/Specifications';

const Home = () => {
  return (
    <>
      <Hero />
      <Features />
      <Specifications />
    </>
  );
};

export default Home;